import { useLocale, useTranslations } from 'next-intl';
import type { MouseEventHandler } from 'react';

import { EventType } from '@/analytics/types';
import stressBlog from '@/app/[locale]/stress/_data/stressBlog';
import ArticleCardsModule from '@/app/components/ArticleCardsModule';
import ArticleCardTag from '@/app/components/ArticleCardsModule/ArticleCardTag';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

const StressBlog = () => {
  const t = useTranslations();
  const locale = useLocale();
  const articles = stressBlog(getLocalePartialUrl(locale));

  const handleLinkClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    const { href } = event.currentTarget;
    const url = new URL(href);
    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'read_more',
      location: 'stress blog',
      action: 'goes to blog',
      path: url.pathname,
    });
  };

  return (
    <ArticleCardsModule
      {...articles}
      data-cy="stress-blog"
      eyebrowText="pulse_blog_eyebrow"
      eyebrowTextColor="light"
      imageTag={() => (
        <ArticleCardTag tag="featured_article_tag" textColor="sandstone-500" />
      )}
      mobileSliderAriaLabels={[
        t('press_section_slide_label_1'),
        t('press_section_slide_label_2'),
        t('press_section_slide_label_3'),
      ]}
      onClick={handleLinkClick}
      swipeableDotsProps={{
        activeColor: 'sandstone-200',
        color: 'gray-400',
      }}
      wrapperClass="bg-purple-600 text-purple-700"
    />
  );
};
export default StressBlog;
